var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { gql } from '@apollo/client';
import styled from 'styled-components';
import { useSnackbarQuery } from '../../__generated__/graphql';
import { Portal } from './portal';
import { apolloClient } from '../../apollo';
var Snackbar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: ", ";\n  display: flex;\n  align-items: center;\n  height: 48px;\n  border-radius: 8px;\n  box-sizing: border-box;\n  padding: 8px 16px;\n  background-color: #ccc;\n  color: #000;\n  line-height: 1.5;\n  z-index: 10000;\n  transition: bottom 0.18s;\n"], ["\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: ", ";\n  display: flex;\n  align-items: center;\n  height: 48px;\n  border-radius: 8px;\n  box-sizing: border-box;\n  padding: 8px 16px;\n  background-color: #ccc;\n  color: #000;\n  line-height: 1.5;\n  z-index: 10000;\n  transition: bottom 0.18s;\n"])), function (props) { return (props.isOpen ? '8px' : -48 - 8 + "px"); });
export var SNACKBAR_QUERY = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query Snackbar {\n    snackbarIsOpen @client\n    snackbarText @client\n  }\n"], ["\n  query Snackbar {\n    snackbarIsOpen @client\n    snackbarText @client\n  }\n"])));
export function SnackbarPortal() {
    var data = useSnackbarQuery().data;
    var isOpen = (data === null || data === void 0 ? void 0 : data.snackbarIsOpen) || false;
    var message = (data === null || data === void 0 ? void 0 : data.snackbarText) || '';
    return (_jsx(Portal, { children: _jsx(Snackbar, __assign({ isOpen: isOpen }, { children: message }), void 0) }, void 0));
}
export function openSnackbar(text) {
    apolloClient.writeQuery({
        query: SNACKBAR_QUERY,
        data: {
            snackbarIsOpen: true,
            snackbarText: text,
        },
    });
    setTimeout(closeSnackbar, 3000);
}
export function closeSnackbar() {
    apolloClient.writeQuery({
        query: SNACKBAR_QUERY,
        data: {
            snackbarIsOpen: false,
            snackbarText: '',
        },
    });
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=snackbar-portal.js.map